import { type ReactElement } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { AuthProvider } from '@citibox-panel/auth';
import { AppErrorBoundary, ThemeProvider } from '@citibox-panel/ui';
import { queryClient } from './lib/queryClient';
import { handleUserChange } from './lib/sessionReset';
import { AppRoutes } from './routes';

export interface AppProps {
  isFirebaseAvailable?: boolean;
}

export function App({ isFirebaseAvailable = true }: AppProps): ReactElement {
  return (
    <ThemeProvider>
      <AppErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <AuthProvider isFirebaseAvailable={isFirebaseAvailable} onUserChange={handleUserChange}>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </AuthProvider>
        </QueryClientProvider>
      </AppErrorBoundary>
    </ThemeProvider>
  );
}
